// ErrorMessageBanner.tsx
import React, { useEffect } from 'react';
import './CompanyManagement.css';

interface ErrorMessageBannerProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
  autoCloseDelay?: number; // Auto close after X milliseconds
}

export const ErrorMessageBanner: React.FC<ErrorMessageBannerProps> = ({
  message,
  isVisible,
  onClose,
  autoCloseDelay = 5000 // Default 5 seconds
}) => {
  useEffect(() => {
    if (isVisible && autoCloseDelay > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [isVisible, autoCloseDelay, onClose]);

  if (!isVisible) return null;

  return (
    <div className="error-message-banner">
      <div className="error-message-icon">
        ✕
      </div>
      <div className="error-message-text">
        {message}
      </div>
      <button
        onClick={onClose}
        className="error-message-close"
        aria-label="Close error message"
      >
        ✕
      </button>
    </div>
  );
};